const RemoveIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.70007 12L18.3038 12" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
)

export default RemoveIcon